/*
  BBJ - Selection de variante par swatch sur la carte produit.
  Au clic : met a jour la variante du formulaire d'ajout au panier,
  l'etat du bouton (disponible / epuise) et l'image de la carte.
  Le prix n'est pas mis a jour : chez BBJ les variantes de couleur
  partagent le meme prix. A revoir si ce n'est plus le cas.
*/
if (!customElements.get('bbj-card-variants')) {
  customElements.define(
    'bbj-card-variants',
    class BbjCardVariants extends HTMLElement {
      connectedCallback() {
        this.item = this.closest('.bbj-has-actions') || this.closest('.grid__item');
        this.actions = this.closest('.bbj-card-actions');
        this.form = this.actions ? this.actions.querySelector('form') : null;
        this.variantInput = this.form ? this.form.querySelector('.product-variant-id') : null;
        this.submit = this.form ? this.form.querySelector('button[type="submit"]') : null;
        this.addEventListener('click', this.onClick.bind(this));
      }

      onClick(event) {
        const swatch = event.target.closest('.bbj-swatch');
        if (!swatch || swatch.classList.contains('is-selected')) return;

        this.querySelectorAll('.bbj-swatch').forEach((node) => {
          const selected = node === swatch;
          node.classList.toggle('is-selected', selected);
          node.setAttribute('aria-checked', selected ? 'true' : 'false');
        });

        const available = swatch.dataset.available === 'true';

        if (this.variantInput) {
          this.variantInput.value = swatch.dataset.variantId;
          this.variantInput.disabled = !available;
        }

        if (this.submit) {
          this.submit.disabled = !available;
          const label = this.submit.querySelector('span:not(.sold-out-message):not(.loading__spinner)');
          if (label) {
            label.textContent = available
              ? this.submit.dataset.addLabel || label.textContent
              : this.submit.dataset.soldLabel || label.textContent;
          }
        }

        this.swapImage(swatch.dataset.image);
      }

      swapImage(url) {
        if (!url || !this.item) return;
        const image = this.item.querySelector('.card__media img');
        if (!image) return;
        image.removeAttribute('srcset');
        image.removeAttribute('sizes');
        image.src = url;
      }
    }
  );
}
